import { Pipe, PipeTransform } from '@angular/core';
import { PermissionAction } from '../models/permission.model';

@Pipe({
  name: 'findAction',
  pure: true,
  standalone: false,
})
export class FindActionPipe implements PipeTransform {
  transform(actions: PermissionAction[], actionName: string): PermissionAction | undefined {
    return actions.find(a => a.action === actionName);
  }
}
